// defaults for our bridge
// whenever you add a new key here, it becomes available on the bridge automatically
const DEFAULTS = {
	t: (key, params) => key,
	mdT: (key, params) => key,
	parseT: T => {
		if (!T) return
		if (typeof T === 'string') return T
		return T.key
	},
	useT: () => ({}),
	navigate: (to, opts) => console.warn(`[bridge] navigation to ${to}`, opts),
	navigateModal: (to, opts) => console.warn(`[bridge] navigation to ${to}`, opts),
	goBack: () => console.warn(`[bridge] goBack not registered`),
	useLocation: () => console.warn(`[bridge] useLocation not registered`),
	useParams: () => console.warn(`[bridge] useLocation not registered`),
	backend: {},
	store: {
		dispatch: () => console.warn('[bridge] dispatch called before store registered'),
		getState: () => ({}),
	},
	roles: {
		useRoleMessage: () => console.warn('[bridge] useRoleMessage called before roles registered'),
		hooklessRoleMessage: () => console.warn('[bridge] hooklessRoleMessage called before roles registered'),
	},
	// FIXME: quick and dirty way to communicate colors in web components. I'd rather pass colors as prop instead of this lookup
	coreStatusColor: {},
	auth: {},
	filters: {},
	trackAnalyticsEvent: () => console.warn('[bridge] trackAnalyticsEvent not registered'),
	useSetQueryParams: () => console.warn('[bridge] useSetQueryParams not registered'),
	useQueryParams: () => console.warn('[bridge] useQueryParams not registered'),

	// Routing components
	Link: () => console.warn('[bridge] Link not registered'),
	ModalLink: () => console.warn('[bridge] ModalLink not registered'),
}

export function createBridge() {
	const registry = Object.fromEntries(Object.entries(DEFAULTS).map(([k, v]) => [k, {current: v}]))

	const fnCache = new Map()
	const objCache = new Map()

	let configured = false

	function setup(cfg = {}) {
		if (configured) return // throw new Error('Bridge already configured')
		for (const [k, v] of Object.entries(cfg)) {
			if (!registry[k]) throw new Error(`Unknown entry "${k}"`)
			registry[k].current = v // mutate in place
		}
		configured = true
	}

	return new Proxy(
		{setup},
		{
			get(_, key) {
				if (key === 'setup') return setup
				if (key === '$$typeof') return undefined // ignore React probes

				const ref = registry[key]
				if (!ref) throw new Error(`No entry named "${key}"`)

				if (typeof ref.current === 'function') {
					if (fnCache.has(key)) return fnCache.get(key)
					const wrapper = (...a) => ref.current(...a) // re‑reads ref
					fnCache.set(key, wrapper)
					return wrapper
				}

				if (objCache.has(key)) return objCache.get(key)
				const proxy = new Proxy(
					{},
					{
						get(_o, prop) {
							const value = ref.current[prop]
							return typeof value === 'function'
								? (...a) => value(...a) // re‑read + call
								: value
						},
					},
				)
				objCache.set(key, proxy)
				return proxy
			},
		},
	)
}
